export const CLI_KIT_VERSION = '3.91.0'
